import { render, staticRenderFns } from "./DonationList.vue?vue&type=template&id=2672130e&"
import script from "./DonationList.vue?vue&type=script&lang=js&"
export * from "./DonationList.vue?vue&type=script&lang=js&"
import style0 from "./DonationList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports